import { Modal as _Modal, ModalProps as _ModalProps } from "reactstrap";

export const Modal = _Modal;
export type ModalProps = _ModalProps;
